import {useEffect, useState} from 'react';
import {ReactComponent as Parrot1} from '../../../assets/images/Parrot_excited_1.svg'
import {ReactComponent as Parrot2} from '../../../assets/images/Parrot_excited_2.svg'
import {ReactComponent as Parrot3} from '../../../assets/images/Parrot_excited_3.svg'
import {ReactComponent as Parrot4} from '../../../assets/images/Parrot_excited_4.svg'

/**
 * 
 * @param int parrotNumber - Choose from 4 parrots to show
 * @param string sideToShow - Sets which side parrot shows on
 * @param int top - style property to move helper down the screen
 * @param boolean isActive - shows parrot helper or not
 * 
 */
const ParrotHelper = ({children, parrotNumber = 1, sideToShow = 'left', isActive = false, showBackground = true, styleOverrides = {}}) => {
    const [activeClass, setActiveClass] = useState('');
    
    const generateParrot = () => {
        switch(parrotNumber) {
            case 1: {
                return <Parrot1 />
            }
            case 2: {
                return <Parrot2 />
            }
            case 3: {
                return <Parrot3 />
            }
            case 4: {
                return <Parrot4 />
            }
        }
    }

    useEffect(() => {
        if( isActive === true ) {
            setActiveClass('active')
        }
    }, [isActive])
    

    return (
        <div className={`parrot-helper ${activeClass} parrot-helper--${sideToShow}`} style={styleOverrides}>
            {showBackground && <div className='parrot-helper--bg'></div>}
            <div className="speech-container">
                <div className="speech-box">{children}</div>
                {generateParrot()}
            </div>
        </div>
    )

}

export default ParrotHelper;
    